export default "__VITE_ASSET__DpP3SbNi__"